export const GOOGLE_MAPS_API_KEY: string = 'AIzaSyDVsgpQY7cbGc9l-yrSpB0arYTXuYhRSzI';
